import { ACCEPT_LEAD_REQUESTED, ACCEPT_LEAD_COMPLETE, ACCEPT_LEAD_FAILED } from '../actions/AcceptLead';
import { CLOSE_SMALL_MODAL } from '../actions/CloseSmallModal';

export const NOT_ACCEPTING = 'NOT_ACCEPTING';
export const ACCEPTING = 'ACCEPTING';
export const ACCEPT_FAILED = 'ACCEPT_FAILED';
export const ACCEPT_SUCCESS = 'ACCEPT_SUCCESS';

const initialState = {
  state: NOT_ACCEPTING,
  lead: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACCEPT_LEAD_REQUESTED:
      return {
        state: ACCEPTING,
        lead: action.lead,
        error: null,
      };
    case ACCEPT_LEAD_COMPLETE:
      return {
        state: ACCEPT_SUCCESS,
        lead: action.lead,
        error: null,
      };
    case ACCEPT_LEAD_FAILED:
      return {
        state: ACCEPT_FAILED,
        lead: action.lead,
        error: action.error,
      };
    case CLOSE_SMALL_MODAL:
      // Reset the state when the modal is closed.
      return initialState;
    default:
      return state;
  }
};
